import { render, staticRenderFns } from "./ItemRecipeIngredientsList.vue?vue&type=template&id=07af09c6&"
import script from "./ItemRecipeIngredientsList.vue?vue&type=script&lang=js&"
export * from "./ItemRecipeIngredientsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports